export default __webpack_public_path__ + "static/media/fbHover.56be64a8.svg";